const $ = require('jquery')
const URI = require('urijs')
const { Model } = require('backbone')
const geocoder = require('shared/javascripts/public_framework/services/google_geocoder')
const { addJsonExtension } = require('../utils/url')

const PARAMS_KEYS = [
  'page',
  'location',
  'radius',
  'latitude',
  'longitude',
  'neLatitude',
  'neLongitude',
  'swLatitude',
  'swLongitude'
]
/**
Temporary solution to store feature flag settings while searching and clearing through filter
*/
const AVAILABLE_FEATURE_FLAGS_KEYS = ['community_events_redesign']
let featureFlags = []
/**
  The model holding state and performing requests for a new content.
  The corresponding view is subscribed to state updates.
  The state is serialized into URL, so pages can be reloaded.
  Also, state updates are stored in the history, so can mimic browser navigation.
*/

export default class EventsListStateV2 extends Model {
  constructor ({ url, content, locations, categoriesFilterLabels, typesFilterLabels, skillsFilterLabels }) {
    const initialState = {
      ...extractQueryParams(url),
      locations: locations,
      content: content,
      url: url,
      categoriesFilterLabels: categoriesFilterLabels,
      typesFilterLabels: typesFilterLabels,
      skillsFilterLabels: skillsFilterLabels,
      loading: false
    }
    storeFeatureFlagParamsFromUrl(url)
    super(initialState)

    $(window).on('popstate.events_list', (e) => {
      const historyState = e.originalEvent.state
      if (historyState) {
        this.set({ ...historyState, history: historyState.url })
      } else {
        this.set({ ...initialState, history: initialState.url })
      }
    })
  }

  /**
   * Removes the subscription to window history.
   */
  destroy () {
    $(window).off('popstate.events_list')
  }

  /**
   * Requests events by URL and updates the state.
   * @param {string} url - backend URL with all the filters applied
   */
  requestEvents (url) {
    this.set({ loading: true })

    return new Promise((resolve, reject) => {
      const jsonUrl = addJsonExtension(url)

      $.ajax({ url: jsonUrl, dataType: 'JSON' })
        .done((res) => {
          const query = extractQueryParams(url)
          const content = res.html
          const locations = res.locations
          const title = res.meta_title
          const description = res.meta_description
          const ogDescription = res.meta_og_description
          const prevLink = res.prev_link
          const nextLink = res.next_link
          const canonicalLink = res.canonical_link
          const categoriesFilterLabels = res.categories_filter_labels
          const typesFilterLabels = res.types_filter_labels
          const skillsFilterLabels = res.skills_filter_labels
          this.set({
            ...query,
            url,
            content,
            locations,
            title,
            description,
            ogDescription,
            prevLink,
            nextLink,
            canonicalLink,
            categoriesFilterLabels,
            typesFilterLabels,
            skillsFilterLabels,
            loading: false
          })
          window.history.pushState(this.attributes, '', url)
          resolve()
        })
        .fail((err) => {
          this.set({ loading: false })
          reject(err)
        })
    })
  }

  /**
   * Requests all events and updates the state.
   */
  requestAllEvents () {
    const url = createURL()
    this.requestEvents(url)
  }

  /**
   * Requests events for a particular city and updates the state.
   * @param {string} locationName - location (city) name to search for
   */
  requestEventsForCity (locationName) {
    return this.getGeocoder()
      .geocodeAddress(locationName)
      .then((res) => {
        if (!res) return null
        return this.requestEventsForBounds(res.geometry.bounds, locationName)
      })
  }

  /**
   * Requests events for bounds and updates the state.
   * @param {object} bounds - Google Maps LatLngBounds object
   * @param {string} locationName - location (city) name associated (optional)
   */
  requestEventsForBounds (bounds, locationName) {
    const { center, northEast, southWest, innerRadius } =
      this.getGeocoder().getBoundsData(bounds)

    return { location: locationName,
      radius: innerRadius / 1000,
      latitude: center.latitude,
      longitude: center.longitude,
      neLatitude: northEast.latitude,
      neLongitude: northEast.longitude,
      swLatitude: southWest.latitude,
      swLongitude: southWest.longitude
    }
  }

  /**
   * Get bounds data for a currently viewed surface.
   * @return {object} bounds - Google Maps LatLngBounds object
   */
  getBoundsFromState () {
    return this.getGeocoder().buildBounds(this.attributes)
  }

  getGeocoder () {
    return geocoder
  }
}

function createURL (params = {}) {
  const pathWithoutTrailingSlash = window.location.pathname.replace(/\/+$/, '')
  return URI(window.location.origin + pathWithoutTrailingSlash)
    .search({ ...params, ...featureFlags })
    .toString()
}

function extractQueryParams (url) {
  const params = URI.parseQuery(url.split('?')[1]) || {}
  const result = {}
  PARAMS_KEYS.forEach((key) => {
    result[key] = params[key]
  })
  return result
}

function storeFeatureFlagParamsFromUrl (url) {
  const params = URI.parseQuery(url.split('?')[1]) || {}
  const result = {}
  AVAILABLE_FEATURE_FLAGS_KEYS.forEach((key) => {
    result[key] = params[key]
  })
  featureFlags = result
}



// WEBPACK FOOTER //
// ./front/apps/public/pages/community/javascripts/models/events_list_state_v2.js